import clsx from 'clsx'
import React from 'react'
import theme from '../styles/theme.module.scss'
import Project from './work-projects-grid-project'
import styles from './work-projects-grid.module.scss'

function ProjectsGrid(props) {
  return (
    <ul className={clsx(styles.root, theme.mB5)}>
      {(props.nodes ?? []).map((node, index) => (
        <Project key={index} {...node} />
      ))}
    </ul>
  );
}

export default ProjectsGrid;
